import React from 'react'

export interface Props {
  children?: React.ReactNode
}

export const Body = (props: Props) => {
  const {children} = props
  return <tbody className="border-0">{children}</tbody>
}
